import { Chip, styled } from "@mui/material";

const NwChip = styled(Chip)(({ theme, color }) => {
  let styles = {};

  if (color === "primary") {
    styles = {
      backgroundColor: theme.nawy.colors.semantic.layer.accentLight,
      color: theme.nawy.colors.semantic.text.accent,
    };
  }

  return {
    ...styles,
    borderRadius: theme.nawy.radius.lg,
  };
});

export default NwChip;
